import React, { FunctionComponent } from 'react';
import SpecificationsDetailList from './specificationsDetailList/SpecificationsDetailList';
import { ISpecGroups } from '../../../../../../gqlCommon/model/IVariants';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';
import SpecificationsAndFeaturesLoader from '../../../../presentational/loaders/SpecificationsAndFeaturesLoader';

export interface ITechnicalSpecificationsContainer {
  technicalSpecifications: ISpecGroups[];
  loading: boolean;
}

const TechnicalSpecificationsContainer: FunctionComponent<ITechnicalSpecificationsContainer> = ({
  technicalSpecifications,
  loading,
}) => {
  if (!technicalSpecifications || loading) {
    return <SpecificationsAndFeaturesLoader />;
  }

  return (
    <SpecificationsDetailList
      title={
        <Translation id="trans__configurator__customise_page_variant_section__specs_modal_specification_subtitle" />
      }
      variantFeatures={technicalSpecifications}
    />
  );
};

export default TechnicalSpecificationsContainer;
